<script setup lang="ts">
const { track } = useAnalytics()

function trackSocialClick(platform: string) {
  track('Social Link Clicked', { platform })
}
</script>

<template>
  <div class="flex items-center">
    <UButton
      icon="i-simple-icons-discord"
      to="https://go.nuxt.com/discord"
      target="_blank"
      variant="ghost"
      color="neutral"
      size="xs"
      @click="trackSocialClick('Discord')"
    >
      <span class="sr-only">Nuxt on Discord</span>
    </UButton>
    <UButton
      icon="i-simple-icons-bluesky"
      to="https://go.nuxt.com/bluesky"
      target="_blank"
      variant="ghost"
      color="neutral"
      size="xs"
      @click="trackSocialClick('Bluesky')"
    >
      <span class="sr-only">Nuxt on Bluesky</span>
    </UButton>
    <UButton
      icon="i-simple-icons-x"
      to="https://go.nuxt.com/x"
      target="_blank"
      variant="ghost"
      color="neutral"
      size="xs"
      @click="trackSocialClick('X')"
    >
      <span class="sr-only">Nuxt on X</span>
    </UButton>
    <UButton
      icon="i-simple-icons-github"
      to="https://go.nuxt.com/github"
      target="_blank"
      variant="ghost"
      color="neutral"
      size="xs"
      @click="trackSocialClick('GitHub')"
    >
      <span class="sr-only">Nuxt on GitHub</span>
    </UButton>
  </div>
</template>
